/* Packages */
import React from 'react';
import {render} from 'react-dom';

/* Helpers */
import {parseDataToProps} from '../helpers';

const productHeroNodes = document.querySelectorAll('.product-hero');

if (productHeroNodes.length > 0) {
    import(/* webpackChunkName: "ProductHero" */ './components/ProductHero').then(({default: ProductHero}) => {
        [...productHeroNodes].forEach((node) => render(<ProductHero {...parseDataToProps(node.dataset)} />, node));
    });
}
